// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Nav_wrapper__-SuCi","brand":"Nav_brand__cneWA","pages":"Nav_pages__1jLwu","active":"Nav_active__3kHRf","account":"Nav_account__3OtGb"};